var _defs, _polyline, _polyline2, _line, _polyline3, _circle, _rect, _path, _path2, _line2, _line3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchitectureDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:none;stroke:#333;stroke-width:2px;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#ffd546;stroke:#ffd546;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 38.17,
    y1: 51.57,
    x2: 38.17,
    y2: 12.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b2deff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd546",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ffd546",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffd546",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ffd546",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffd546",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ffd546",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#ffd546",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#ffd546",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#ffd546",
    stopOpacity: 0
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.35 17.56 22.35 7.52 54 7.52 54 47.08 22.35 47.08 22.35 29.86"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "22.35 17.56 22.35 7.52 54 7.52 54 47.08 22.35 47.08 22.35 29.86"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.17,
    y1: 23.34,
    x2: 38.17,
    y2: 27.87
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "44.96 32.39 44.96 27.86 31.39 27.86 31.39 32.39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.39,
    cy: 36.91,
    r: 4.52
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 40.43,
    y: 32.39,
    width: 9.04,
    height: 9.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.17,18a4.64,4.64,0,0,0,4.53-4.85V11.54a4.64,4.64,0,0,0-4.53-4.85,4.64,4.64,0,0,0-4.52,4.85v1.61A4.64,4.64,0,0,0,12.17,18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.83,55.3V25.91h6.78c3.41,0,4.52-2,4.52-4.52H7.65C3.6,21.39,2,23.1,2,28.17v7.91c0,2.43,1,4.52,3.39,4.52H6.52"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.17,
    y1: 37.21,
    x2: 12.17,
    y2: 55.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.52,
    y1: 28.17,
    x2: 6.52,
    y2: 55.3
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.17 14.3 32.52 23.34 43.83 23.34 38.17 14.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchitectureDesign);
export default __webpack_public_path__ + "static/media/architecture-design.99284694f63360b287bd155ace4fd732.svg";
export { ForwardRef as ReactComponent };